webpackJsonp([270189111676482],{

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/goose.3b555786.jpg";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _work = __webpack_require__(25);
	
	var _work2 = _interopRequireDefault(_work);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var goose = __webpack_require__(124);
	
	var Goose = function Goose() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Goose | Cory Schadt',
	      bodyAttributes: {
	        class: 'inner'
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'page fade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Goose'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Goose is travel insurance made easy.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Primary Role:  HTML, CSS, Responsive Design, WordPress Theme Creation.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'btn', target: '_blank', href: 'https://www.gooseinsurance.com/' },
	                'View Project'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-feature' },
	        _react2.default.createElement(_work2.default, { noLink: true, raise: true, laptop: true, screen: goose, color: '#F13697' })
	      )
	    )
	  );
	};
	exports.default = Goose;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-goose-js-6db13ac87c09518a98b8.js